// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__I62Gq","modal":"Modal_modal__eeF_g","xs":"Modal_xs__ayzCh","s":"Modal_s__Yml3K","m":"Modal_m__8xvxx","l":"Modal_l__Y0c8u","close":"Modal_close__gTDC0"};